'use strict';

export default class DirectoryFormController {
  errors = {
    saveDirectory: undefined,
    other: undefined
  };

  message = '';
  submitted = false;

  year = new Date().getFullYear();
  yearsToList = 2;
  years = [];

  categories = ['Restaurants', 'Hotels', 'Markets', 'Beer, Wine & Spirits', 'Entertainment', 'Appliance Installation',
  'Band', 'DJ', 'Retail', 'Transportation', 'Realtors', 'Contractors', 'Landscapers', 'Roofing',
  'Electrician', 'Plumbers', 'Painters', 'Bottled Gas', 'Land Surveyor', 'Mason',
  'Handyman', 'Pool Care', 'Exterminator', 'Building Supplies', 'Carting Services', 'Insurance',
  'Marinas', 'Auto Transport', 'Emergency Contacts', 'Cleaning Services', 'Government',
  'Computer & IT Support', 'Health & Wellness', 'Misc.'];

  /*@ngInject*/
  constructor(Upload, Directory, directory, $state, Slug, marked, $sce) {
    this.$sce = $sce;
    this.$marked = marked;
    this._$state = $state;
    this._Directory = Directory;
    this.$Uploader = Upload;
    this.$Slug = Slug;

    this.loading = false;

    this.mission = null;
    if(!directory) {
      this.setDirectory();
    } else {
      this.data = directory;
    }
    if(this._$state.current.name == 'directory.edit') {
      this.mission = 'edit';
      this.pageTitle = 'Edit Directory';
    } else {
      this.mission = 'new';
      this.pageTitle = 'Create New Directory';
    }
  }

  setDirectory() {
    this.data = {
      title: '',
      town: '',
      phone: null,
      phoneAlt: null,
      url: null,
      address: {},
      category: [],
      note: null
    };
  }

  saveDirectory(form) {
    this.submitted = true;
    console.log(form);
    if(form.$valid) {
      this.loading = true;
      this._Directory.save(this.data)
          .then(res => {
            this.loading = false;
            console.log('Result', res);
            this._$state.go('directory.list');
          })
          .catch(err => {
            this.loading = false;
            this.error.saveDirectory = err.data.message;
            console.log('Error', err);
          });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/directory/form/form.controller.js